// Generated by tools/art/build.py — do not edit.
//
// The wardrobe, as shapes rather than pictures. Every `body` carries `{T}` for
// the dye and `{TL}`/`{TD}` for the highlight and shadow derived from it, so
// twelve dyes are twelve strings rather than twelve drawings
// ([D-041](../../../docs/DECISIONS.md#d-041)). Anything written as a literal
// colour is a fixed part and never tints.
//
// Coordinates are the avatar template's, 160×240 ([Avatar](../../../docs/AVATAR.md)).
export const WARDROBE_SLOTS = ["hat", "glasses", "top", "neck", "shoes", "held"];
export const RARITIES = ["common", "rare", "epic"];
/** The twelve, and the only colours an item may be dyed. */
export const DYES = {
    berry: "#E85B7A",
    coral: "#F2784B",
    gold: "#F2B705",
    sand: "#D9B27C",
    leaf: "#5BC46A",
    mint: "#63C9B0",
    sky: "#5EA8D8",
    ink: "#3D4557",
    grape: "#9B6FD1",
    rose: "#F0A6C0",
    slate: "#6E7C93",
    cream: "#F1E3C6",
};
export const DYE_ORDER = Object.keys(DYES);
export const WARDROBE = [
    {
        id: "hat.party-hat",
        slot: "hat",
        name: "Party hat",
        rarity: "common",
        price: 150,
        tint: "#E85B7A",
        body: "<path d=\"M46 44 L80 4 L114 44 Z\" fill=\"{T}\"/><path d=\"M46 44 L80 4 L80 44 Z\" fill=\"{TL}\"/><path d=\"M46 44 Q80 56 114 44 Q80 52 46 44 Z\" fill=\"{TD}\"/><circle cx=\"80\" cy=\"6\" r=\"7\" fill=\"#C9A227\"/><circle cx=\"78\" cy=\"4\" r=\"2.4\" fill=\"#FFDA6B\"/><path d=\"M58 32 L70 36 M88 26 L100 30\" stroke=\"#FFF\" stroke-width=\"4\" stroke-linecap=\"round\"/>",
    },
    {
        id: "hat.beanie",
        slot: "hat",
        name: "Winter beanie",
        rarity: "common",
        price: 160,
        tint: "#5EA8D8",
        body: "<path d=\"M44 46 Q44 12 80 12 Q116 12 116 46 Z\" fill=\"{T}\"/><path d=\"M44 46 Q44 12 80 12 Q80 12 80 46 Z\" fill=\"{TL}\"/><rect x=\"40\" y=\"42\" width=\"80\" height=\"13\" rx=\"6.5\" fill=\"{TD}\"/><circle cx=\"80\" cy=\"10\" r=\"9\" fill=\"#F6EEDD\"/>",
    },
    {
        id: "hat.cap",
        slot: "hat",
        name: "Cap",
        rarity: "common",
        price: 150,
        tint: "#3D4557",
        body: "<path d=\"M46 44 Q46 14 80 14 Q114 14 114 44 Z\" fill=\"{T}\"/><path d=\"M46 44 Q46 14 80 14 Q80 14 80 44 Z\" fill=\"{TL}\"/><path d=\"M112 44 Q140 44 138 52 Q112 54 112 44 Z\" fill=\"{TD}\"/><circle cx=\"80\" cy=\"16\" r=\"4\" fill=\"{TD}\"/>",
    },
    {
        id: "hat.flower-crown",
        slot: "hat",
        name: "Flower crown",
        rarity: "rare",
        price: 560,
        tint: "#F0A6C0",
        body: "<path d=\"M42 44 Q80 30 118 44 Q80 38 42 44 Z\" fill=\"#4E9E3E\"/><circle cx=\"50.0\" cy=\"36.7\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"55.0\" cy=\"40.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"53.1\" cy=\"46.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"46.9\" cy=\"46.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"45.0\" cy=\"40.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"50.0\" cy=\"42.0\" r=\"2.9\" fill=\"#C9A227\"/><circle cx=\"66.0\" cy=\"30.7\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"71.0\" cy=\"34.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"69.1\" cy=\"40.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"62.9\" cy=\"40.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"61.0\" cy=\"34.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"66.0\" cy=\"36.0\" r=\"2.9\" fill=\"#C9A227\"/><circle cx=\"80.0\" cy=\"27.7\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"85.0\" cy=\"31.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"83.1\" cy=\"37.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"76.9\" cy=\"37.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"75.0\" cy=\"31.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"80.0\" cy=\"33.0\" r=\"2.9\" fill=\"#C9A227\"/><circle cx=\"94.0\" cy=\"30.7\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"99.0\" cy=\"34.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"97.1\" cy=\"40.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"90.9\" cy=\"40.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"89.0\" cy=\"34.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"94.0\" cy=\"36.0\" r=\"2.9\" fill=\"#C9A227\"/><circle cx=\"110.0\" cy=\"36.7\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"115.0\" cy=\"40.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"113.1\" cy=\"46.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"106.9\" cy=\"46.3\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"105.0\" cy=\"40.4\" r=\"4.4\" fill=\"{T}\"/><circle cx=\"110.0\" cy=\"42.0\" r=\"2.9\" fill=\"#C9A227\"/>",
    },
    {
        id: "hat.crown",
        slot: "hat",
        name: "Crown",
        rarity: "epic",
        price: 1600,
        tint: "#F2B705",
        body: "<path d=\"M48 46 L48 22 L62 34 L80 16 L98 34 L112 22 L112 46 Z\" fill=\"{T}\"/><path d=\"M48 46 L48 22 L62 34 L80 16 L80 46 Z\" fill=\"{TL}\"/><rect x=\"46\" y=\"44\" width=\"68\" height=\"10\" rx=\"5\" fill=\"{TD}\"/><circle cx=\"80\" cy=\"49\" r=\"4\" fill=\"#CC4A5F\"/><circle cx=\"60\" cy=\"49\" r=\"3\" fill=\"#4A90C4\"/><circle cx=\"100\" cy=\"49\" r=\"3\" fill=\"#4E9E3E\"/>",
    },
    {
        id: "hat.space-helmet",
        slot: "hat",
        name: "Space helmet",
        rarity: "epic",
        price: 2000,
        tint: "#6E7C93",
        body: "<path d=\"M40 78 Q40 26 80 26 Q120 26 120 78 Z\" fill=\"{T}\" opacity=\".35\"/><path d=\"M40 78 Q40 26 80 26 Q120 26 120 78\" fill=\"none\" stroke=\"{T}\" stroke-width=\"6\"/><rect x=\"36\" y=\"74\" width=\"88\" height=\"12\" rx=\"6\" fill=\"{TD}\"/><path d=\"M54 44 Q60 32 74 30\" fill=\"none\" stroke=\"#FFF\" stroke-width=\"5\" stroke-linecap=\"round\" opacity=\".75\"/>",
    },
    {
        id: "hat.pirate-hat",
        slot: "hat",
        name: "Pirate hat",
        rarity: "rare",
        price: 700,
        tint: "#3D4557",
        body: "<path d=\"M34 46 Q46 24 60 34 Q80 6 100 34 Q114 24 126 46 Q80 36 34 46 Z\" fill=\"{T}\"/><path d=\"M34 46 Q46 24 60 34 Q80 6 80 38 Q56 38 34 46 Z\" fill=\"{TL}\"/><path d=\"M34 46 Q80 36 126 46 Q80 42 34 46 Z\" fill=\"{TD}\"/><circle cx=\"80\" cy=\"28\" r=\"7\" fill=\"#F6EEDD\"/><circle cx=\"77.4\" cy=\"27\" r=\"1.6\" fill=\"#2E2A26\"/><circle cx=\"82.6\" cy=\"27\" r=\"1.6\" fill=\"#2E2A26\"/><path d=\"M72 38 L88 32 M72 32 L88 38\" stroke=\"#F6EEDD\" stroke-width=\"2.4\" stroke-linecap=\"round\"/>",
    },
    {
        id: "hat.wizard-hat",
        slot: "hat",
        name: "Wizard hat",
        rarity: "rare",
        price: 740,
        tint: "#9B6FD1",
        body: "<path d=\"M52 48 Q70 -2 96 6 Q82 26 108 48 Z\" fill=\"{T}\"/><path d=\"M52 48 Q70 -2 96 6 Q80 26 80 48 Z\" fill=\"{TL}\"/><rect x=\"42\" y=\"44\" width=\"76\" height=\"12\" rx=\"6\" fill=\"{TD}\"/><path d=\"M70 26 l2.6 5.4 l5.8 .8 l-4.2 4.2 l1 5.8 l-5.2 -2.8 l-5.2 2.8 l1 -5.8 l-4.2 -4.2 l5.8 -.8 Z\" fill=\"#C9A227\"/>",
    },
    {
        id: "glasses.round",
        slot: "glasses",
        name: "Round glasses",
        rarity: "common",
        price: 150,
        tint: "#3D4557",
        body: "<g fill=\"none\" stroke=\"{T}\" stroke-width=\"4\"><circle cx=\"59\" cy=\"78\" r=\"12\"/><circle cx=\"101\" cy=\"78\" r=\"12\"/><path d=\"M71 78 H89\"/></g><circle cx=\"59\" cy=\"78\" r=\"12\" fill=\"#FFF\" opacity=\".28\"/><circle cx=\"101\" cy=\"78\" r=\"12\" fill=\"#FFF\" opacity=\".28\"/><path d=\"M53 72 a9 9 0 0 1 6 -4\" fill=\"none\" stroke=\"#FFF\" stroke-width=\"3\" stroke-linecap=\"round\" opacity=\".7\"/>",
    },
    {
        id: "glasses.star-frames",
        slot: "glasses",
        name: "Star frames",
        rarity: "rare",
        price: 620,
        tint: "#F2B705",
        body: "<g fill=\"none\" stroke=\"{T}\" stroke-width=\"4\" stroke-linejoin=\"round\"><path d=\"M59 66 l3.4 7 l7.6 1 l-5.5 5.4 l1.3 7.6 l-6.8 -3.6 l-6.8 3.6 l1.3 -7.6 l-5.5 -5.4 l7.6 -1 Z\"/><path d=\"M101 66 l3.4 7 l7.6 1 l-5.5 5.4 l1.3 7.6 l-6.8 -3.6 l-6.8 3.6 l1.3 -7.6 l-5.5 -5.4 l7.6 -1 Z\"/><path d=\"M70 78 H90\"/></g>",
    },
    {
        id: "glasses.heart-frames",
        slot: "glasses",
        name: "Heart frames",
        rarity: "rare",
        price: 620,
        tint: "#E85B7A",
        body: "<g fill=\"none\" stroke=\"{T}\" stroke-width=\"4\" stroke-linejoin=\"round\"><path d=\"M59 87 q-11 -8 -11 -14 a5.5 5.5 0 0 1 11 -3 a5.5 5.5 0 0 1 11 3 q0 6 -11 14 Z\"/><path d=\"M101 87 q-11 -8 -11 -14 a5.5 5.5 0 0 1 11 -3 a5.5 5.5 0 0 1 11 3 q0 6 -11 14 Z\"/><path d=\"M70 76 H90\"/></g>",
    },
    {
        id: "glasses.swim-goggles",
        slot: "glasses",
        name: "Swim goggles",
        rarity: "common",
        price: 180,
        tint: "#63C9B0",
        body: "<rect x=\"44\" y=\"68\" width=\"30\" height=\"20\" rx=\"9\" fill=\"{T}\"/><rect x=\"86\" y=\"68\" width=\"30\" height=\"20\" rx=\"9\" fill=\"{T}\"/><path d=\"M74 78 H86\" stroke=\"{TD}\" stroke-width=\"5\"/><rect x=\"48\" y=\"71\" width=\"22\" height=\"9\" rx=\"4.5\" fill=\"#FFF\" opacity=\".45\"/><rect x=\"90\" y=\"71\" width=\"22\" height=\"9\" rx=\"4.5\" fill=\"#FFF\" opacity=\".45\"/>",
    },
    {
        id: "glasses.square-frames",
        slot: "glasses",
        name: "Square frames",
        rarity: "common",
        price: 150,
        tint: "#6E7C93",
        body: "<g fill=\"none\" stroke=\"{T}\" stroke-width=\"4\" stroke-linejoin=\"round\"><rect x=\"47\" y=\"69\" width=\"24\" height=\"18\" rx=\"4\"/><rect x=\"89\" y=\"69\" width=\"24\" height=\"18\" rx=\"4\"/><path d=\"M71 78 H89\"/></g><rect x=\"47\" y=\"69\" width=\"24\" height=\"18\" rx=\"4\" fill=\"#FFF\" opacity=\".26\"/><rect x=\"89\" y=\"69\" width=\"24\" height=\"18\" rx=\"4\" fill=\"#FFF\" opacity=\".26\"/>",
    },
    {
        id: "glasses.hero-mask",
        slot: "glasses",
        name: "Hero mask",
        rarity: "epic",
        price: 1300,
        tint: "#E85B7A",
        body: "<path fill-rule=\"evenodd\" fill=\"{T}\" d=\"M38 74 Q58 60 80 70 Q102 60 122 74 Q124 88 108 92 Q92 94 80 84 Q68 94 52 92 Q36 88 38 74 Z M50 79 a9 7 0 1 0 18 0 a9 7 0 1 0 -18 0 Z M92 79 a9 7 0 1 0 18 0 a9 7 0 1 0 -18 0 Z\"/><path d=\"M40 74 Q58 62 80 71 Q102 62 120 74 Q102 67 80 75 Q58 67 40 74 Z\" fill=\"{TL}\"/><path d=\"M40 78 Q30 76 22 84 Q32 84 40 82 Z\" fill=\"{TD}\"/><path d=\"M40 82 Q32 90 26 98 Q36 94 42 86 Z\" fill=\"{TD}\"/>",
    },
    {
        id: "glasses.ski-goggles",
        slot: "glasses",
        name: "Ski goggles",
        rarity: "rare",
        price: 680,
        tint: "#F2784B",
        body: "<path d=\"M42 76 q38 -14 76 0 l0 14 q-38 12 -76 0 Z\" fill=\"{T}\"/><path d=\"M42 76 q38 -14 76 0 l0 5 q-38 -12 -76 0 Z\" fill=\"{TL}\"/><path d=\"M48 80 q32 -9 64 0 l0 7 q-32 8 -64 0 Z\" fill=\"#2E2A26\" opacity=\".55\"/><path d=\"M56 83 q14 -4 24 -1\" fill=\"none\" stroke=\"#FFF\" stroke-width=\"3\" stroke-linecap=\"round\" opacity=\".55\"/>",
    },
    {
        id: "top.stripy-top",
        slot: "top",
        name: "Stripy top",
        rarity: "common",
        price: 160,
        tint: "#5EA8D8",
        body: "<path d=\"M46 126 Q80 118 114 126 L114 176 Q80 184 46 176 Z\" fill=\"{T}\"/><path d=\"M46 126 Q80 118 114 126 L114 134 Q80 126 46 134 Z\" fill=\"{TL}\"/><path d=\"M46 140 h68 M46 154 h68 M46 168 h68\" stroke=\"#F6EEDD\" stroke-width=\"6\"/>",
    },
    {
        id: "top.rainbow-jumper",
        slot: "top",
        name: "Rainbow jumper",
        rarity: "rare",
        price: 590,
        tint: "#F2B705",
        body: "<path d=\"M46 126 Q80 118 114 126 L114 176 Q80 184 46 176 Z\" fill=\"{T}\"/><path d=\"M46 126 Q80 118 114 126 L114 134 Q80 126 46 134 Z\" fill=\"{TL}\"/><path d=\"M46 142 h68\" stroke=\"#CC4A5F\" stroke-width=\"6\"/><path d=\"M46 154 h68\" stroke=\"#4E9E3E\" stroke-width=\"6\"/><path d=\"M46 166 h68\" stroke=\"#4A90C4\" stroke-width=\"6\"/>",
    },
    {
        id: "top.raincoat",
        slot: "top",
        name: "Raincoat",
        rarity: "common",
        price: 200,
        tint: "#F2B705",
        body: "<path d=\"M46 126 Q80 118 114 126 L114 176 Q80 184 46 176 Z\" fill=\"{T}\"/><path d=\"M46 126 Q80 118 114 126 L114 134 Q80 126 46 134 Z\" fill=\"{TL}\"/><path d=\"M80 122 v58\" stroke=\"{TD}\" stroke-width=\"3\"/><path d=\"M56 120 q24 16 48 0 q-24 8 -48 0 Z\" fill=\"{TD}\"/><circle cx=\"86\" cy=\"146\" r=\"3\" fill=\"#F6EEDD\"/><circle cx=\"86\" cy=\"162\" r=\"3\" fill=\"#F6EEDD\"/>",
    },
    {
        id: "top.explorer-jacket",
        slot: "top",
        name: "Explorer jacket",
        rarity: "rare",
        price: 800,
        tint: "#D9B27C",
        body: "<path d=\"M46 126 Q80 118 114 126 L114 176 Q80 184 46 176 Z\" fill=\"{T}\"/><path d=\"M46 126 Q80 118 114 126 L114 134 Q80 126 46 134 Z\" fill=\"{TL}\"/><rect x=\"52\" y=\"146\" width=\"18\" height=\"14\" rx=\"3\" fill=\"{TD}\"/><rect x=\"90\" y=\"146\" width=\"18\" height=\"14\" rx=\"3\" fill=\"{TD}\"/><path d=\"M80 122 v58\" stroke=\"{TD}\" stroke-width=\"3\"/><rect x=\"46\" y=\"164\" width=\"68\" height=\"7\" rx=\"3\" fill=\"{TD}\"/><rect x=\"74\" y=\"162\" width=\"12\" height=\"11\" rx=\"2\" fill=\"#C9A227\"/>",
    },
    {
        id: "top.cape",
        slot: "top",
        name: "Cape",
        rarity: "epic",
        price: 1300,
        tint: "#9B6FD1",
        body: "<path d=\"M44 126 Q80 118 116 126 L126 182 Q80 194 34 182 Z\" fill=\"{T}\"/><path d=\"M44 126 Q80 118 116 126 L118 140 Q80 130 42 140 Z\" fill=\"{TL}\"/><path d=\"M80 124 v66\" stroke=\"{TD}\" stroke-width=\"3\" opacity=\".5\"/><circle cx=\"62\" cy=\"124\" r=\"5\" fill=\"#C9A227\"/><circle cx=\"98\" cy=\"124\" r=\"5\" fill=\"#C9A227\"/>",
    },
    {
        id: "top.astronaut-suit",
        slot: "top",
        name: "Astronaut suit",
        rarity: "epic",
        price: 1500,
        tint: "#F1E3C6",
        body: "<path d=\"M44 126 Q80 116 116 126 L116 178 Q80 186 44 178 Z\" fill=\"{T}\"/><path d=\"M44 126 Q80 116 116 126 L116 134 Q80 124 44 134 Z\" fill=\"{TL}\"/><rect x=\"42\" y=\"118\" width=\"76\" height=\"9\" rx=\"4.5\" fill=\"#9AA3AD\"/><rect x=\"64\" y=\"140\" width=\"32\" height=\"20\" rx=\"4\" fill=\"#5F6B80\"/><circle cx=\"72\" cy=\"150\" r=\"3.2\" fill=\"#CC4A5F\"/><circle cx=\"80\" cy=\"150\" r=\"3.2\" fill=\"#E9C33A\"/><circle cx=\"88\" cy=\"150\" r=\"3.2\" fill=\"#4A90C4\"/><rect x=\"44\" y=\"166\" width=\"72\" height=\"7\" rx=\"3\" fill=\"{TD}\"/><path d=\"M52 136 v24 M108 136 v24\" stroke=\"{TD}\" stroke-width=\"3\" stroke-linecap=\"round\"/>",
    },
    {
        id: "top.dungarees",
        slot: "top",
        name: "Dungarees",
        rarity: "common",
        price: 180,
        tint: "#3D4557",
        body: "<path d=\"M46 138 Q80 132 114 138 L114 176 Q80 184 46 176 Z\" fill=\"{T}\"/><path d=\"M58 118 l6 22 M102 118 l-6 22\" stroke=\"{T}\" stroke-width=\"8\" stroke-linecap=\"round\"/><rect x=\"66\" y=\"146\" width=\"28\" height=\"20\" rx=\"4\" fill=\"{TD}\"/><circle cx=\"60\" cy=\"140\" r=\"3.4\" fill=\"#C9A227\"/><circle cx=\"100\" cy=\"140\" r=\"3.4\" fill=\"#C9A227\"/>",
    },
    {
        id: "top.lab-coat",
        slot: "top",
        name: "Lab coat",
        rarity: "rare",
        price: 680,
        tint: "#F1E3C6",
        body: "<path d=\"M46 126 Q80 118 114 126 L114 178 Q80 186 46 178 Z\" fill=\"{T}\"/><path d=\"M46 126 Q80 118 114 126 L114 134 Q80 126 46 134 Z\" fill=\"{TL}\"/><path d=\"M66 120 L80 140 L94 120\" fill=\"none\" stroke=\"{TD}\" stroke-width=\"3\"/><rect x=\"52\" y=\"152\" width=\"16\" height=\"13\" rx=\"2\" fill=\"{TD}\"/><path d=\"M56 154 v9\" stroke=\"#4A90C4\" stroke-width=\"3\" stroke-linecap=\"round\"/>",
    },
    {
        id: "neck.scarf",
        slot: "neck",
        name: "Scarf",
        rarity: "common",
        price: 150,
        tint: "#E85B7A",
        body: "<path d=\"M50 104 q30 20 60 0 q2 7 0 15 q-30 20 -60 0 q-2 -7 0 -15 Z\" fill=\"{T}\"/><path d=\"M50 104 q30 20 60 0 q1 3 0 5 q-30 20 -60 0 q-1 -2 0 -5 Z\" fill=\"{TL}\"/><path d=\"M68 118 l-5 30 h13 l3 -30 Z\" fill=\"{TD}\"/><path d=\"M79 120 l3 38 h13 l-5 -38 Z\" fill=\"{T}\"/><path d=\"M64 149 v6 M69 149 v6 M74 149 v6\" stroke=\"#F6EEDD\" stroke-width=\"3\" stroke-linecap=\"round\"/><path d=\"M84 159 v6 M89 159 v6 M94 159 v6\" stroke=\"#F6EEDD\" stroke-width=\"3\" stroke-linecap=\"round\"/>",
    },
    {
        id: "neck.rainbow-scarf",
        slot: "neck",
        name: "Rainbow scarf",
        rarity: "epic",
        price: 1400,
        tint: "#9B6FD1",
        body: "<path d=\"M50 104 q30 20 60 0 q2 7 0 15 q-30 20 -60 0 q-2 -7 0 -15 Z\" fill=\"{T}\"/><path d=\"M50 104 q30 20 60 0 q1 3 0 5 q-30 20 -60 0 q-1 -2 0 -5 Z\" fill=\"{TL}\"/><path d=\"M68 118 l-5 30 h13 l3 -30 Z\" fill=\"{TD}\"/><path d=\"M79 120 l3 38 h13 l-5 -38 Z\" fill=\"{T}\"/><path d=\"M67 126 h10\" stroke-width=\"4\" stroke=\"#CC4A5F\"/><path d=\"M66 133 h10\" stroke-width=\"4\" stroke=\"#E9C33A\"/><path d=\"M65 140 h10\" stroke-width=\"4\" stroke=\"#4E9E3E\"/><path d=\"M80 130 h10\" stroke-width=\"4\" stroke=\"#CC4A5F\"/><path d=\"M81 138 h10\" stroke-width=\"4\" stroke=\"#E9C33A\"/><path d=\"M81 146 h11\" stroke-width=\"4\" stroke=\"#4E9E3E\"/><path d=\"M82 154 h12\" stroke-width=\"4\" stroke=\"#4A90C4\"/><path d=\"M64 149 v6 M69 149 v6 M74 149 v6\" stroke=\"#F6EEDD\" stroke-width=\"3\" stroke-linecap=\"round\"/><path d=\"M84 159 v6 M89 159 v6 M94 159 v6\" stroke=\"#F6EEDD\" stroke-width=\"3\" stroke-linecap=\"round\"/>",
    },
    {
        id: "neck.bow-tie",
        slot: "neck",
        name: "Bow tie",
        rarity: "common",
        price: 150,
        tint: "#E85B7A",
        body: "<path d=\"M80 116 L58 106 L58 126 Z\" fill=\"{T}\"/><path d=\"M80 116 L102 106 L102 126 Z\" fill=\"{T}\"/><path d=\"M80 116 L58 106 L58 116 Z\" fill=\"{TL}\"/><rect x=\"74\" y=\"110\" width=\"12\" height=\"12\" rx=\"4\" fill=\"{TD}\"/>",
    },
    {
        id: "neck.medal",
        slot: "neck",
        name: "Medal",
        rarity: "rare",
        price: 560,
        tint: "#5EA8D8",
        body: "<path d=\"M68 106 L80 128 L92 106\" fill=\"none\" stroke=\"{T}\" stroke-width=\"7\"/><circle cx=\"80\" cy=\"136\" r=\"11\" fill=\"#C9A227\"/><circle cx=\"80\" cy=\"136\" r=\"7\" fill=\"#FFDA6B\"/><path d=\"M80 131 l1.6 3.4 l3.6 .5 l-2.6 2.6 l.6 3.6 l-3.2 -1.7 l-3.2 1.7 l.6 -3.6 l-2.6 -2.6 l3.6 -.5 Z\" fill=\"#C9A227\"/>",
    },
    {
        id: "neck.flower-chain",
        slot: "neck",
        name: "Flower chain",
        rarity: "rare",
        price: 590,
        tint: "#F0A6C0",
        body: "<path d=\"M54 112 Q80 134 106 112\" fill=\"none\" stroke=\"#4E9E3E\" stroke-width=\"4\"/><circle cx=\"58.0\" cy=\"111.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"62.1\" cy=\"114.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"60.6\" cy=\"119.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"55.4\" cy=\"119.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"53.9\" cy=\"114.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"58.0\" cy=\"116.0\" r=\"2.4\" fill=\"#C9A227\"/><circle cx=\"69.0\" cy=\"119.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"73.1\" cy=\"122.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"71.6\" cy=\"127.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"66.4\" cy=\"127.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"64.9\" cy=\"122.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"69.0\" cy=\"124.0\" r=\"2.4\" fill=\"#C9A227\"/><circle cx=\"80.0\" cy=\"122.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"84.1\" cy=\"125.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"82.6\" cy=\"130.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"77.4\" cy=\"130.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"75.9\" cy=\"125.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"80.0\" cy=\"127.0\" r=\"2.4\" fill=\"#C9A227\"/><circle cx=\"91.0\" cy=\"119.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"95.1\" cy=\"122.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"93.6\" cy=\"127.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"88.4\" cy=\"127.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"86.9\" cy=\"122.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"91.0\" cy=\"124.0\" r=\"2.4\" fill=\"#C9A227\"/><circle cx=\"102.0\" cy=\"111.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"106.1\" cy=\"114.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"104.6\" cy=\"119.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"99.4\" cy=\"119.5\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"97.9\" cy=\"114.7\" r=\"3.6\" fill=\"{T}\"/><circle cx=\"102.0\" cy=\"116.0\" r=\"2.4\" fill=\"#C9A227\"/>",
    },
    {
        id: "neck.bandana",
        slot: "neck",
        name: "Bandana",
        rarity: "common",
        price: 150,
        tint: "#F2784B",
        body: "<path d=\"M56 110 Q80 118 104 110 L104 118 Q80 132 56 118 Z\" fill=\"{T}\"/><path d=\"M56 110 Q80 118 104 110 L104 113 Q80 121 56 113 Z\" fill=\"{TL}\"/><circle cx=\"66\" cy=\"118\" r=\"2.4\" fill=\"#F6EEDD\"/><circle cx=\"80\" cy=\"123\" r=\"2.4\" fill=\"#F6EEDD\"/><circle cx=\"94\" cy=\"118\" r=\"2.4\" fill=\"#F6EEDD\"/>",
    },
    {
        id: "neck.whistle",
        slot: "neck",
        name: "Whistle",
        rarity: "common",
        price: 170,
        tint: "#6E7C93",
        body: "<path d=\"M64 104 L79 127 M96 104 L81 127\" stroke=\"#5F6B80\" stroke-width=\"3.5\"/><rect x=\"60\" y=\"126\" width=\"30\" height=\"17\" rx=\"8\" fill=\"{T}\"/><rect x=\"60\" y=\"126\" width=\"30\" height=\"6\" rx=\"3\" fill=\"{TL}\"/><path d=\"M88 130 h12 q3 0 3 4 v5 q0 4 -3 4 h-12 Z\" fill=\"{TD}\"/><ellipse cx=\"70\" cy=\"130\" rx=\"5\" ry=\"2.6\" fill=\"#2E2A26\"/>",
    },
    {
        id: "shoes.trainers",
        slot: "shoes",
        name: "Trainers",
        rarity: "common",
        price: 150,
        tint: "#F2B705",
        body: "<path d=\"M48 199 h12 v10 h20 q8 0 8 8 v2 H48 Z\" fill=\"{T}\"/><path d=\"M48 199 h12 v4 H48 Z\" fill=\"{TL}\"/><path d=\"M84 199 h12 v10 h20 q8 0 8 8 v2 H84 Z\" fill=\"{T}\"/><path d=\"M84 199 h12 v4 H84 Z\" fill=\"{TL}\"/><rect x=\"46\" y=\"218\" width=\"44\" height=\"8\" rx=\"4\" fill=\"#F6EEDD\"/><rect x=\"82\" y=\"218\" width=\"44\" height=\"8\" rx=\"4\" fill=\"#F6EEDD\"/><path d=\"M62 217 q8 -6 18 -6\" fill=\"none\" stroke=\"#F6EEDD\" stroke-width=\"4\" stroke-linecap=\"round\"/><path d=\"M98 217 q8 -6 18 -6\" fill=\"none\" stroke=\"#F6EEDD\" stroke-width=\"4\" stroke-linecap=\"round\"/>",
    },
    {
        id: "shoes.boots",
        slot: "shoes",
        name: "Boots",
        rarity: "common",
        price: 190,
        tint: "#D9B27C",
        body: "<path d=\"M48 198 h26 v20 h6 v7 H48 Z\" fill=\"{T}\"/><path d=\"M84 198 h26 v20 h6 v7 H84 Z\" fill=\"{T}\"/><path d=\"M48 198 h26 v6 H48 Z\" fill=\"{TL}\"/><path d=\"M84 198 h26 v6 H84 Z\" fill=\"{TL}\"/><rect x=\"46\" y=\"220\" width=\"38\" height=\"6\" rx=\"3\" fill=\"#4A3B2C\"/><rect x=\"82\" y=\"220\" width=\"38\" height=\"6\" rx=\"3\" fill=\"#4A3B2C\"/>",
    },
    {
        id: "shoes.wellies",
        slot: "shoes",
        name: "Wellies",
        rarity: "common",
        price: 180,
        tint: "#5BC46A",
        body: "<path d=\"M50 194 h22 v24 h8 v8 H50 Z\" fill=\"{T}\"/><path d=\"M86 194 h22 v24 h8 v8 H86 Z\" fill=\"{T}\"/><path d=\"M50 194 h22 v7 H50 Z\" fill=\"{TL}\"/><path d=\"M86 194 h22 v7 H86 Z\" fill=\"{TL}\"/><rect x=\"48\" y=\"221\" width=\"34\" height=\"6\" rx=\"3\" fill=\"{TD}\"/><rect x=\"84\" y=\"221\" width=\"34\" height=\"6\" rx=\"3\" fill=\"{TD}\"/>",
    },
    {
        id: "shoes.flippers",
        slot: "shoes",
        name: "Flippers",
        rarity: "rare",
        price: 500,
        tint: "#63C9B0",
        body: "<path d=\"M46 204 h30 l10 22 h-42 Z\" fill=\"{T}\"/><path d=\"M84 204 h30 l2 22 h-42 Z\" fill=\"{T}\"/><path d=\"M46 204 h30 l3 6 h-34 Z\" fill=\"{TL}\"/><path d=\"M84 204 h30 l1 6 h-34 Z\" fill=\"{TL}\"/><path d=\"M56 212 v12 M66 212 v12 M94 212 v12 M104 212 v12\" stroke=\"{TD}\" stroke-width=\"2.4\"/>",
    },
    {
        id: "shoes.skates",
        slot: "shoes",
        name: "Roller skates",
        rarity: "epic",
        price: 1200,
        tint: "#E85B7A",
        body: "<rect x=\"48\" y=\"198\" width=\"30\" height=\"20\" rx=\"7\" fill=\"{T}\"/><rect x=\"84\" y=\"198\" width=\"30\" height=\"20\" rx=\"7\" fill=\"{T}\"/><rect x=\"48\" y=\"198\" width=\"30\" height=\"7\" rx=\"3.5\" fill=\"{TL}\"/><rect x=\"84\" y=\"198\" width=\"30\" height=\"7\" rx=\"3.5\" fill=\"{TL}\"/><rect x=\"48\" y=\"218\" width=\"30\" height=\"4\" rx=\"2\" fill=\"#5F6B80\"/><rect x=\"84\" y=\"218\" width=\"30\" height=\"4\" rx=\"2\" fill=\"#5F6B80\"/><circle cx=\"54\" cy=\"226\" r=\"4.5\" fill=\"#F6EEDD\"/><circle cx=\"72\" cy=\"226\" r=\"4.5\" fill=\"#F6EEDD\"/><circle cx=\"90\" cy=\"226\" r=\"4.5\" fill=\"#F6EEDD\"/><circle cx=\"108\" cy=\"226\" r=\"4.5\" fill=\"#F6EEDD\"/>",
    },
    {
        id: "shoes.rocket-boots",
        slot: "shoes",
        name: "Rocket boots",
        rarity: "epic",
        price: 1600,
        tint: "#6E7C93",
        body: "<path d=\"M48 196 h26 v18 q8 0 8 6 v4 H48 Z\" fill=\"{T}\"/><path d=\"M84 196 h26 v18 q8 0 8 6 v4 H84 Z\" fill=\"{T}\"/><path d=\"M48 196 h26 v6 H48 Z\" fill=\"{TL}\"/><path d=\"M84 196 h26 v6 H84 Z\" fill=\"{TL}\"/><rect x=\"48\" y=\"206\" width=\"26\" height=\"5\" fill=\"{TD}\"/><rect x=\"84\" y=\"206\" width=\"26\" height=\"5\" fill=\"{TD}\"/><path d=\"M51 224 h18 l-3 4 h-12 Z\" fill=\"#5F6B80\"/><path d=\"M87 224 h18 l-3 4 h-12 Z\" fill=\"#5F6B80\"/><path d=\"M53 228 q-2 6 7 12 q9 -6 7 -12 Z\" fill=\"#E8632B\"/><path d=\"M89 228 q-2 6 7 12 q9 -6 7 -12 Z\" fill=\"#E8632B\"/><path d=\"M56 228 q-1 4 4 8 q5 -4 4 -8 Z\" fill=\"#FFC247\"/><path d=\"M92 228 q-1 4 4 8 q5 -4 4 -8 Z\" fill=\"#FFC247\"/>",
    },
    {
        id: "shoes.slippers",
        slot: "shoes",
        name: "Slippers",
        rarity: "common",
        price: 150,
        tint: "#F0A6C0",
        body: "<path d=\"M46 208 q16 -8 32 0 v10 q-16 8 -32 0 Z\" fill=\"{T}\"/><path d=\"M82 208 q16 -8 32 0 v10 q-16 8 -32 0 Z\" fill=\"{T}\"/><path d=\"M46 208 q16 -8 32 0 v3 q-16 -6 -32 0 Z\" fill=\"{TL}\"/><path d=\"M82 208 q16 -8 32 0 v3 q-16 -6 -32 0 Z\" fill=\"{TL}\"/><circle cx=\"62\" cy=\"206\" r=\"5\" fill=\"#F6EEDD\"/><circle cx=\"98\" cy=\"206\" r=\"5\" fill=\"#F6EEDD\"/>",
    },
    {
        id: "held.balloon",
        slot: "held",
        name: "Balloon",
        rarity: "common",
        price: 150,
        tint: "#E85B7A",
        body: "<path d=\"M132 136 v34\" stroke=\"#5F6B80\" stroke-width=\"2\"/><ellipse cx=\"132\" cy=\"122\" rx=\"17\" ry=\"20\" fill=\"{T}\"/><ellipse cx=\"126\" cy=\"114\" rx=\"5\" ry=\"7\" fill=\"#FFF\" opacity=\".45\"/><path d=\"M132 142 l-4 6 h8 Z\" fill=\"{TD}\"/>",
    },
    {
        id: "held.umbrella",
        slot: "held",
        name: "Umbrella",
        rarity: "common",
        price: 190,
        tint: "#5EA8D8",
        body: "<path d=\"M132 170 v-44\" stroke=\"#8B5E3C\" stroke-width=\"4\"/><path d=\"M132 170 q0 8 -8 8\" fill=\"none\" stroke=\"#8B5E3C\" stroke-width=\"4\"/><path d=\"M108 126 q24 -30 48 0 q-12 -8 -24 0 q-12 -8 -24 0 Z\" fill=\"{T}\"/><path d=\"M108 126 q24 -30 48 0 q-12 -8 -24 0 Z\" fill=\"{TL}\"/>",
    },
    {
        id: "held.book",
        slot: "held",
        name: "Book",
        rarity: "common",
        price: 160,
        tint: "#9B6FD1",
        body: "<path d=\"M114 142 h34 v34 h-34 Z\" fill=\"{T}\"/><path d=\"M114 142 h34 v6 h-34 Z\" fill=\"{TL}\"/><path d=\"M118 146 v26\" stroke=\"{TD}\" stroke-width=\"3\"/><rect x=\"124\" y=\"152\" width=\"20\" height=\"4\" rx=\"2\" fill=\"#F6EEDD\"/><rect x=\"124\" y=\"160\" width=\"20\" height=\"4\" rx=\"2\" fill=\"#F6EEDD\"/>",
    },
    {
        id: "held.backpack",
        slot: "held",
        name: "Backpack",
        rarity: "common",
        price: 200,
        tint: "#5BC46A",
        body: "<rect x=\"112\" y=\"140\" width=\"34\" height=\"38\" rx=\"10\" fill=\"{T}\"/><rect x=\"112\" y=\"140\" width=\"34\" height=\"10\" rx=\"5\" fill=\"{TL}\"/><rect x=\"118\" y=\"158\" width=\"22\" height=\"14\" rx=\"4\" fill=\"{TD}\"/><rect x=\"126\" y=\"134\" width=\"6\" height=\"10\" rx=\"3\" fill=\"{TD}\"/><circle cx=\"129\" cy=\"165\" r=\"2.6\" fill=\"#C9A227\"/>",
    },
    {
        id: "held.flag",
        slot: "held",
        name: "Flag",
        rarity: "rare",
        price: 560,
        tint: "#F2784B",
        body: "<path d=\"M116 182 v-52\" stroke=\"#8B5E3C\" stroke-width=\"4\"/><path d=\"M118 130 q18 4 30 -4 v22 q-12 8 -30 4 Z\" fill=\"{T}\"/><path d=\"M118 130 q18 4 30 -4 v6 q-12 8 -30 4 Z\" fill=\"{TL}\"/><circle cx=\"116\" cy=\"128\" r=\"4\" fill=\"#C9A227\"/>",
    },
    {
        id: "held.lantern",
        slot: "held",
        name: "Lantern",
        rarity: "rare",
        price: 680,
        tint: "#F2B705",
        body: "<path d=\"M132 128 q0 -10 0 -12\" stroke=\"#5F6B80\" stroke-width=\"3\" fill=\"none\"/><path d=\"M120 130 h24 l-4 34 h-16 Z\" fill=\"{T}\"/><path d=\"M120 130 h24 l-1 8 h-22 Z\" fill=\"{TL}\"/><rect x=\"118\" y=\"126\" width=\"28\" height=\"6\" rx=\"3\" fill=\"#5F6B80\"/><rect x=\"122\" y=\"162\" width=\"20\" height=\"6\" rx=\"3\" fill=\"#5F6B80\"/><circle cx=\"132\" cy=\"146\" r=\"6\" fill=\"#FFDA6B\"/>",
    },
    {
        id: "held.kite",
        slot: "held",
        name: "Kite",
        rarity: "rare",
        price: 600,
        tint: "#F2784B",
        body: "<path d=\"M132 170 Q124 150 140 132\" fill=\"none\" stroke=\"#5F6B80\" stroke-width=\"1.6\"/><path d=\"M142 92 L156 110 L142 132 L128 110 Z\" fill=\"{T}\"/><path d=\"M142 92 L156 110 L142 110 Z\" fill=\"{TL}\"/><path d=\"M128 110 L142 132 L142 110 Z\" fill=\"{TD}\"/><path d=\"M142 92 V132 M128 110 H156\" stroke=\"#8B5E3C\" stroke-width=\"1.6\"/><path d=\"M126 144 l6 3 l-6 3 Z M130 156 l6 3 l-6 3 Z\" fill=\"#F6EEDD\"/>",
    },
    {
        id: "held.magic-wand",
        slot: "held",
        name: "Magic wand",
        rarity: "epic",
        price: 1500,
        tint: "#9B6FD1",
        body: "<path d=\"M124 176 L137 136\" stroke=\"#2E2A26\" stroke-width=\"5\" stroke-linecap=\"round\"/><path d=\"M133 148 L137 136\" stroke=\"#F6EEDD\" stroke-width=\"5\" stroke-linecap=\"round\"/><path d=\"M138.0 111.0 L141.4 119.3 L150.4 120.0 L143.6 125.8 L145.6 134.5 L138.0 129.8 L130.4 134.5 L132.4 125.8 L125.6 120.0 L134.6 119.3 Z\" fill=\"{T}\"/><path d=\"M138.0 118.5 L139.5 122.0 L143.2 122.3 L140.4 124.8 L141.2 128.4 L138.0 126.5 L134.8 128.4 L135.6 124.8 L132.8 122.3 L136.5 122.0 Z\" fill=\"{TL}\"/><path d=\"M152.0 100.0 L153.1 102.5 L155.8 102.8 L153.7 104.6 L154.4 107.2 L152.0 105.8 L149.6 107.2 L150.3 104.6 L148.2 102.8 L150.9 102.5 Z\" fill=\"#FFDA6B\"/><path d=\"M122.0 103.0 L122.8 104.9 L124.9 105.1 L123.3 106.4 L123.8 108.4 L122.0 107.3 L120.2 108.4 L120.7 106.4 L119.1 105.1 L121.2 104.9 Z\" fill=\"#FFDA6B\"/><path d=\"M154.0 133.4 L154.7 135.1 L156.5 135.2 L155.1 136.4 L155.5 138.1 L154.0 137.2 L152.5 138.1 L152.9 136.4 L151.5 135.2 L153.3 135.1 Z\" fill=\"#FFDA6B\"/>",
    },
    {
        id: "held.trophy",
        slot: "held",
        name: "Trophy",
        rarity: "epic",
        price: 1800,
        tint: "#F2B705",
        body: "<path d=\"M118 136 C112 136 112 150 122 150\" fill=\"none\" stroke=\"{TD}\" stroke-width=\"3.5\"/><path d=\"M146 136 C152 136 152 150 142 150\" fill=\"none\" stroke=\"{TD}\" stroke-width=\"3.5\"/><path d=\"M118 132 h28 q0 24 -14 28 q-14 -4 -14 -28 Z\" fill=\"{T}\"/><path d=\"M118 132 h10 q0 20 4 28 q-14 -4 -14 -28 Z\" fill=\"{TL}\"/><rect x=\"129\" y=\"159\" width=\"6\" height=\"8\" fill=\"{TD}\"/><rect x=\"121\" y=\"166\" width=\"22\" height=\"9\" rx=\"2\" fill=\"#4A3B2C\"/><path d=\"M132.0 139.0 L133.3 142.2 L136.8 142.5 L134.1 144.7 L134.9 148.0 L132.0 146.2 L129.1 148.0 L129.9 144.7 L127.2 142.5 L130.7 142.2 Z\" fill=\"#F6EEDD\"/>",
    },
];
//# sourceMappingURL=wardrobe.generated.js.map